import { Fragment, useEffect, useState } from 'react'
import { Breadcrumb, BreadcrumbItem, UncontrolledTooltip } from 'reactstrap'
import { HelpCircle } from 'react-feather'
import { useParams } from 'react-router-dom'
const BreadcrumbsAlignment = ({ firstLevel, secondLevel, stageName, instructions }) => {
  const [menuCollapsed, setMenuCollapsed] = useState(false)
  const { woId } = useParams()
  useEffect(() => {
    if (window.localStorage.getItem("menuCollapsed")) {
      setMenuCollapsed(JSON.parse(window.localStorage.getItem("menuCollapsed")))
    }
  }, [window.localStorage.getItem("menuCollapsed")])

  return (
    <Fragment>
      <div className='breadcrumb-wrapper' style={{ marginLeft: menuCollapsed ? '32px' : '32px' }}>
        <Breadcrumb>
          <BreadcrumbItem>
            <span> {firstLevel} </span>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <span> {secondLevel} </span>
          </BreadcrumbItem>
          <BreadcrumbItem>
            {instructions ? (
              <Fragment>
                <span style={{ color: "#00b0c6" }}> {woId} <HelpCircle size={16} id="positionType" /> </span>
                <UncontrolledTooltip placement='bottom' target='positionType'>
                  {stageName} - {instructions}
                </UncontrolledTooltip>
              </Fragment>
            ) : (
              <span style={{ color: "#00b0c6" }}> {woId ? woId : ''} </span>
            )}
          </BreadcrumbItem>
        </Breadcrumb>
      </div>
    </Fragment>
  )
}
export default BreadcrumbsAlignment